// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__QGiyu","title":"FrontImage_title__2WRTe"};